<template>
  <ListLayout
    :title="`${supportModule.support}`"
    :tableData="ticketList"
    :tableHeader="tableHeaders"
    :total="totalItems"
    :fieldsNotInColumnSelect="['actions', 'remarks']"
    @getList="getTicketList"
    :context="context"
    :isColumnShowVisibility="true"
    ref="listTable"
  >
    <template #listAction>
      <PrimaryButton
        :id="`${supportModule.support} Add`"
        class="mr-2"
        :to="{ name: 'add-support-user-ticket' }"
        name="Add Ticket"
        icon="mdi-plus"
        iconSize="x-large"
      >
      </PrimaryButton>
    </template>
    <template #rightFilterSlot>
      <div class="w-100 d-flex align-center justify-end">
        <RefreshListButton
          id="supportUserTicketRefreshList"
          :isIcon="false"
          @click="$refs.listTable.searchTriggered()"
        />
      </div>
    </template>
    <template #dialogs>
      <TicketStatusForm
        v-model="openStatusChangeDialog"
        :id="ticketId"
        :itemPriorityList="itemPriorityList"
        ref="ticketStatusChange"
        @getList="getTicketList"
      />
    </template>
  </ListLayout>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import SupportUserTicketButton from "@/components/Button/SupportUserTicketButton.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import SupportBusinessImpact from "@/components/AgIcon/SupportBusinessImpact.vue";
import SupportPriority from "@/components/AgIcon/SupportPriority.vue";
import SupportStatus from "@/components/AgIcon/SupportStatus.vue";
import TicketRemarks from "@/components/AgIcon/TicketRemarks.vue";
import TicketStatusForm from "@/components/ModuleBasedComponents/SupportUser/TicketStatusForm.vue";
import { supportModule } from "@/utils/moduleMapping";
import RefreshListButton from "@/components/BaseComponents/RefreshListButton.vue";

export default {
  components: {
    SupportUserTicketButton,
    ListLayout,
    SupportBusinessImpact,
    SupportStatus,
    SupportPriority,
    TicketRemarks,
    TicketStatusForm,
    RefreshListButton,
  },
  data() {
    return {
      supportModule,
      permissions: null,
      totalItems: 0,
      filters: {},
      ticketList: [],
      headerSelected: [
        {
          headerName: "Ticket ID",
          field: "ticket_no",
          sortable: true,
          pinned: "left",
          minWidth: 150,
        },
        {
          headerName: "Title",
          field: "title",
          sortable: true,
          tooltipField: "title",
        },
        {
          headerName: "Company",
          field: "company_name",
          sortable: true,
          tooltipField: "company name",
        },
        {
          headerName: "Module",
          field: "module",
        },
        {
          headerName: "Status",
          field: "status",
          cellRenderer: "SupportStatus",
        },
        {
          headerName: "Business Impact",
          field: "impact",
          cellRenderer: "SupportBusinessImpact",
        },
        {
          headerName: "Priority",
          field: "priority",
          cellRenderer: "SupportPriority",
        },

        {
          headerName: "Created At",
          field: "created",
        },
        {
          headerName: "Resolution Date",
          field: "resolution_date",
        },
      ],
      openStatusChangeDialog: false,
      ticketId: null,
      itemPriorityList: [],
    };
  },
  computed: {
    tableHeaders() {
      return [
        ...this.headerSelected,
        {
          headerName: "",
          field: "remarks",
          pinned: "left",
          minWidth: 70,
          sortable: false,
          width: 70,
          cellRenderer: "TicketRemarks",
        },
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 160,
          sortable: false,
          width: 160,
          cellRenderer: "SupportUserTicketButton",
        },
      ];
    },
    context() {
      return { parentComponent: this };
    },
  },
  methods: {
    ticketStatus(data) {
      this.openStatusChangeDialog = true;
      this.ticketId = data.id;
      this.itemPriorityList = data.possible_status;
    },
    getTicketList(params = {}) {
      bus.$emit("showLoader", true);
      this.$api.supportUserTicket
        .getSupportList(params)
        .then((res) => {
          this.ticketList = res.data;
          this.totalItems = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>
